export const FETCH_MOVIE = "movie/fetchSuccess";
export const ONE_MOVIE = "oneMovie/fetchSuccess";

export const GENRE_MOVIE = "genres/fetchSuccess";
export const ONE_GENRE = "genre/fetchSuccess";

export const CAST_MOVIE = "cast/fetchSuccess";
